import { useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { articleBySlug } from '../lib/articles'

function setMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`)
  if (!el) { el = document.createElement('meta'); el.setAttribute('name', name); document.head.appendChild(el) }
  el.setAttribute('content', content)
}

// Stiluri pentru corpul markdown — pe tokenii vorba (ink pe bone trece WCAG).
const MD = {
  h2: (p) => <h2 className="font-sans font-semibold tracking-tight mt-12 mb-4 text-3xl leading-snug text-ink md:text-4xl" {...p} />,
  h3: (p) => <h3 className="font-sans font-semibold tracking-tight mt-10 mb-3 text-2xl text-ink" {...p} />,
  p: (p) => <p className="mt-4 text-lg leading-relaxed text-ink-soft" {...p} />,
  ul: (p) => <ul className="mt-4 list-disc space-y-2 pl-6 text-lg text-ink-soft" {...p} />,
  ol: (p) => <ol className="mt-4 list-decimal space-y-2 pl-6 text-lg text-ink-soft" {...p} />,
  strong: (p) => <strong className="font-semibold text-ink" {...p} />,
  blockquote: (p) => <blockquote className="mt-6 border-l-2 border-honey pl-5 text-ink-muted" {...p} />,
  a: (p) => <a className="text-ink underline decoration-honey underline-offset-2 transition-colors hover:text-honey-deep" {...p} />,
}

export default function Article() {
  const { slug } = useParams()
  const a = articleBySlug[slug]

  useEffect(() => {
    if (a) { document.title = `${a.title} — vorba.dev`; setMeta('description', a.description || '') }
  }, [a])

  if (!a) {
    return (
      <section data-theme="light" className="px-5 py-40 text-ink md:px-10">
        <div className="mx-auto max-w-site">
          <p className="eyebrow mb-6">404 ✦</p>
          <h1 className="font-sans font-semibold tracking-tight text-5xl">Articolul nu există.</h1>
          <Link to="/articole" className="mt-8 inline-block font-mono text-xs uppercase tracking-[0.1em] text-ink transition-colors hover:text-honey-deep">← toate articolele</Link>
        </div>
      </section>
    )
  }

  return (
    <section data-theme="light" className="px-5 pb-28 pt-32 text-ink md:px-10 md:pb-40 md:pt-40">
      <article className="mx-auto max-w-3xl">
        <Link to="/articole" className="mb-10 inline-block font-mono text-[12px] uppercase tracking-[0.1em] text-ink-muted transition-colors hover:text-honey-deep">← Articole</Link>
        <p className="eyebrow mb-5">{a.industry || 'Articol'}{a.market ? ` · ${a.market.toUpperCase()}` : ''} ✦</p>
        <h1 className="font-sans font-semibold tracking-tight text-4xl leading-[1.1] md:text-6xl">{a.title}</h1>
        {a.description && <p className="mt-6 max-w-2xl text-xl leading-relaxed text-ink-soft md:text-2xl">{a.description}</p>}
        <p className="mt-5 font-mono text-[12px] uppercase tracking-[0.1em] text-ink-muted">{a.date}{a.readingMinutes ? ` · ${a.readingMinutes} min` : ''}</p>

        <div className="mt-12">
          <ReactMarkdown remarkPlugins={[remarkGfm]} components={MD}>{a.body}</ReactMarkdown>
        </div>

        <div className="mt-16 border-t border-ink/15 pt-10">
          <a href="mailto:hello@vorba.dev?subject=Fit%20call" className="inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3 font-mono text-xs uppercase tracking-[0.08em] text-cream transition-colors duration-300 hover:bg-honey hover:text-ink">Book a 15-min fit call <span aria-hidden>→</span></a>
        </div>
      </article>
    </section>
  )
}
